module.exports = __webpack_public_path__ + "static/media/WingBg03-sm.c1ae50eb.jpg";